import { CognitoGroup } from 'config/permissions';

export function isUserAdmin(userGroups: string[]): boolean {
  if (userGroups.length === 0) return false;

  return userGroups.includes(CognitoGroup.ADMIN);
}
